import { FC } from 'react';

export const CollectOut: FC = (props) => (
	<svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
		<g clipPath="url(#clip0_2721_470)">
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M11.2929 0.292893C11.6834 -0.0976311 12.3166 -0.0976311 12.7071 0.292893L15.7071 3.29289C16.0976 3.68342 16.0976 4.31658 15.7071 4.70711C15.3166 5.09763 14.6834 5.09763 14.2929 4.70711L13 3.41421L13 9.73684C13 10.2891 12.5523 10.7368 12 10.7368C11.4477 10.7368 11 10.2891 11 9.73684L11 3.41421L9.70711 4.70711C9.31658 5.09763 8.68342 5.09763 8.29289 4.70711C7.90237 4.31658 7.90237 3.68342 8.29289 3.29289L11.2929 0.292893ZM7.91915 8.60608C8.1367 9.11371 7.90155 9.70159 7.39392 9.91914L5.93912 10.5426L12 13.3948L18.0609 10.5426L16.6061 9.91914C16.0985 9.70159 15.8633 9.11371 16.0809 8.60608C16.2984 8.09845 16.8863 7.8633 17.3939 8.08086L20.8939 9.58086C21.2616 9.73843 21.5 10.1 21.5 10.5V18.3654C21.5 19.1401 21.0526 19.8452 20.3516 20.175L12.4258 23.9048C12.1561 24.0317 11.8439 24.0317 11.5742 23.9048L3.64841 20.175C2.94742 19.8452 2.5 19.1401 2.5 18.3654V10.5C2.5 10.1 2.7384 9.73843 3.10608 9.58086L6.60608 8.08086C7.11371 7.8633 7.70159 8.09845 7.91915 8.60608ZM19.5 12.0758L13 15.1346V21.4242L19.5 18.3654V12.0758ZM11 21.4242V15.1346L4.5 12.0758V18.3654L11 21.4242Z"
				fill="currentColor"
			/>
		</g>
		<defs>
			<clipPath id="clip0_2721_470">
				<rect width="24" height="24" fill="white" />
			</clipPath>
		</defs>
	</svg>
);
